import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/marketing/edit.svg'
import _imports_1 from '@/assets/marketing/add-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-33a6ab7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tpl-sidebar" }
const _hoisted_2 = { class: "tpl-sidebar_search" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  class: "iconfont icon-baocuo"
}
const _hoisted_5 = { class: "tpl-sidebar_list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_9 = { class: "tpl-content_main" }

import { ref, reactive, toRaw, onBeforeMount, PropType } from 'vue'
import HeaderTitle from './components/HeaderTitle.vue'
import MainForm from './components/MainForm.vue'
import CosFullLayout from '@/components/CosFullLayout/index.vue'
import CosFixFooterPage from '@/components/CosFullLayout/fixFooterPage.vue'
import minusCircleWhite from '@/assets/marketing/minus-circle-white.svg'
import minusCircleBlack from '@/assets/marketing/minus-circle-black.svg'
import Modal from '@/hooks/modalType'
import { message } from '@dc-platform/dc-components'
import { templateList, templateCreate, templateUpdate, templateDelete } from '@/api/marketing/marketingManage'
import type { TemplateParams, TemplateListItem, TemplateEditParams } from '@/typings/api/marketingManage'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'DcCosZbuTemplateManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  subdomain: {
    type: String as PropType<'fbu' | 'lbu'>,
    required: true
  },
  permission: {
    type: Object as PropType<{
      add: string
      edit: string
      del: string
    }>,
    required: true
  }
},
  setup(__props) {

const { t } = useI18n()



const listData = ref<TemplateListItem[]>()
const pageTotal = ref<number>(0)
const queryForm = reactive<TemplateParams>({
  pageNumber: 1,
  pageSize: 10,
  keyword: ''
})
const getList = (pageNumber = 1) => {
  const params = toRaw({ ...queryForm, pageNumber })
  templateList(params).then((res) => {
    listData.value = res.data.items
    queryForm.pageNumber = res.data.pageNumber
    queryForm.pageSize = res.data.pageSize
    pageTotal.value = res.data.totalCount
    if (res.data.items?.length) {
      currentId.value = res.data.items[isActiveIndex.value].id
    }
  })
}
const handleCurrentChange = (page: number) => getList(page)
onBeforeMount(getList)

const tplStatus = ref<'view' | 'edit' | 'add'>('view')
const isAdd = ref<boolean>(false)
const isActiveIndex = ref<number>(0)
const currentId = ref<number>()
const handleTplDelete = (row: TemplateListItem) => {
  Modal.delete({
    name: row.name,
    onOk() {
      templateDelete({ templateId: row.id }).then((res) => {
        message.success(t('marketing.删除模板成功'))
        isActiveIndex.value = 0
        getList()
      })
    }
  })
}
const handleTplAdd = () => {
  currentId.value = undefined
  isAdd.value = false
  tplStatus.value = 'edit'
}
const toggleList = () => {
  isAdd.value = !isAdd.value
}
const handleClick = (index: number, id: number) => {
  tplStatus.value = 'view'
  isActiveIndex.value = index
  currentId.value = id
}

const handleEdit = () => {
  tplStatus.value = 'edit'
}
const handleCancel = () => {
  tplStatus.value = 'view'
  if (listData.value?.length) {
    currentId.value = listData.value[isActiveIndex.value]?.id
  } else {
    currentId.value = undefined
  }
}

const mainForm = ref()
const handleSubmit = () => {
  mainForm.value.handleSubmit()
}
const onSubmit = async (data: TemplateEditParams) => {
  const params = Object.assign({}, data)
  params.config = JSON.stringify(params.config)
  params.globalConfig = JSON.stringify(params.globalConfig)
  delete params.fileList
  try {
    if (params.templateId) {
      await templateUpdate(params)
      message.success(t('marketing.编辑模板成功'))
    } else {
      await templateCreate(params)
      message.success(t('marketing.新增模板成功'))
    }
    currentId.value = undefined
    tplStatus.value = 'view'
    getList()
  } catch (error) {
    console.log(error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_dc_layout_button_group = _resolveComponent("dc-layout-button-group")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(CosFullLayout, { class: "tpl-container" }, {
    aside: _withCtx(() => [
      _createVNode(CosFixFooterPage, { autoFooter: false }, {
        footer: _withCtx(() => [
          (listData.value?.length)
            ? (_openBlock(), _createBlock(_component_a_pagination, {
                key: 0,
                size: "small",
                style: {"padding-bottom":"10px"},
                current: queryForm.pageNumber,
                "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.pageNumber) = $event)),
                pageSize: queryForm.pageSize,
                "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.pageSize) = $event)),
                total: pageTotal.value,
                "show-total": (total) => _unref(t)('marketing.共个模板', {total: total}),
                onChange: handleCurrentChange
              }, null, 8, ["current", "pageSize", "total", "show-total"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(HeaderTitle, {
              title: _unref(t)('marketing.模板管理')
            }, null, 8, ["title"]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_input, {
                value: queryForm.keyword,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.keyword) = $event)),
                valueModifiers: { trim: true },
                maxlength: 100,
                placeholder: _unref(t)('marketing.模板名称/说明'),
                onPressEnter: _cache[1] || (_cache[1] = ($event: any) => (getList()))
              }, null, 8, ["value", "placeholder"]),
              _createVNode(_component_a_button, {
                class: _normalizeClass({ 'no-border': isAdd.value }),
                onClick: toggleList
              }, {
                icon: _withCtx(() => [
                  (!isAdd.value)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                    : (_openBlock(), _createElementBlock("span", _hoisted_4))
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _createElementVNode("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["tpl-sidebar_list__item", { active: isActiveIndex.value === index && currentId.value }]),
                  key: index
                }, [
                  _createElementVNode("p", {
                    onClick: ($event: any) => (handleClick(index, item.id))
                  }, _toDisplayString(`${index + 1}、${item.name}`), 9, _hoisted_6),
                  (isAdd.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: isActiveIndex.value === index ? _unref(minusCircleWhite) : _unref(minusCircleBlack),
                        onClick: ($event: any) => (handleTplDelete(item))
                      }, null, 8, _hoisted_7)), [
                        [_directive_permission, __props.permission.del]
                      ])
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ]),
            (!listData.value?.length)
              ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
                  key: 0,
                  type: "nothing"
                }))
              : _createCommentVNode("", true),
            (isAdd.value)
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "tpl-add-button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handleTplAdd()))
                }, [
                  _hoisted_8,
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('marketing.新增模板')), 1)
                ])), [
                  [_directive_permission, __props.permission.add]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    main: _withCtx(() => [
      _createVNode(CosFixFooterPage, null, {
        footer: _withCtx(() => [
          _createVNode(_component_dc_layout_button_group, null, {
            default: _withCtx(() => [
              (tplStatus.value === 'view' && listData.value?.length)
                ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (handleEdit()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
                    ]),
                    _: 1
                  })), [
                    [_directive_permission, __props.permission.edit]
                  ])
                : _createCommentVNode("", true),
              (tplStatus.value !== 'view')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (handleSubmit()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('btn.save')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (handleCancel()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('btn.cancel')), 1)
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(HeaderTitle, {
              title: _unref(t)('marketing.模板详情')
            }, null, 8, ["title"]),
            _createVNode(MainForm, {
              subdomain: __props.subdomain,
              templateId: currentId.value,
              status: tplStatus.value,
              ref_key: "mainForm",
              ref: mainForm,
              onSubmit: onSubmit
            }, null, 8, ["subdomain", "templateId", "status"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})